<template>
  <div id="index">
    <!-- <Hezuo></Hezuo> -->
    <div class="visible-xs min_index">
      <!-- 头部 -->
      <MinHeader
        :searchText="searchText"
        ref="header"
        @searchFun="searchFun"
      ></MinHeader>
      <div style="width: 100%; height: 50px"></div>
      <div class="searchtext">
        您搜索关键词 <span style="color: red"> {{ searchText }}</span> 的 结果
      </div>
      <!-- tab -->
      <div class="tab1">
        <div>
          <div
            style="position: relative"
            @click="clicktab(1)"
          >
            <span>文章 </span>
            <i
              class="tabactiv"
              v-if="tabindex === 1"
            ></i>
          </div>
          <div
            style="position: relative"
            @click="clicktab(2)"
          >
            <span>视频 </span>
            <i
              class="tabactiv"
              v-if="tabindex === 2"
            ></i>
          </div>
          <div
            style="position: relative"
            @click="clicktab(3)"
          >
            <span>直播 </span>
            <i
              class="tabactiv"
              v-if="tabindex === 3"
            ></i>
          </div>
        </div>
      </div>
      <!-- 加载 -->
      <div
        class="claloadding"
        v-if="oidug"
      >
        <img
          src="@/assets/img/loadding_pc.gif"
          alt=""
        >
        <div>努力加载中...</div>
      </div>

      <!-- 空 -->
      <div
        class="claloadding"
        v-if="!oidug&&list_arr.length===0"
      >
        <img
          src="@/assets/img/kkry_pc.gif"
          alt=""
        >
        <div>空空如也...</div>
      </div>
      <!-- 文章 -->
      <div
        class="lm_content clearfix"
        v-if="tabindex === 1"
      >
        <div
          class="lm_con_item"
          v-for="item in list_arr"
          :key="item.news_id"
          @click="new_details(item.news_id)"
        >
          <img
            :src="item.cover[0]"
            alt=""
            style="display: inline-block"
          />
          <div
            class="lm_con_right"
            style="display: inline-block"
          >
            <div
              class="lm_con_top"
              v-html="formatet(item.title)"
            ></div>
            <div
              class="lm_con_mm"
              v-html="formatet(item.summary)"
            ></div>
            <div class="lm_con_bot">
              <span class="renwu"><i class="el-icon-user-solid"></i>{{ item.user }}</span>
              <span style="padding-top: 2px;">{{ item.create_time.split(" ")[0] }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 视频播放 -->
      <div
        class="spvidio clearfix"
        v-if="tabindex === 2"
      >
        <div
          v-for="item in list_arr"
          :key="item.video_id"
          @click="godetitl(item)"
        >
          <img
            class="spvideoimg"
            :src="item.cover"
            alt=""
          />
          <div class="top_left_over"></div>
          <img
            src="@/assets/img/home/icon_bf.png"
            alt=""
            class="play_icon"
          />
          <p
            class="video_title"
            v-html="formatet(item.title)"
          ></p>
        </div>
      </div>
      <!-- 直播 -->
      <div
        class="zb_content clearfix"
        v-if="tabindex === 3"
      >
        <!-- item -->
        <div
          @click="details(item)"
          class="zb_con_item"
          v-for="item in list_arr"
          :key="item.id"
        >
          <img
            :src="item.cover"
            alt=""
          />
          <div>
            <div class="zb_con_title">
              <span v-html="formatet(item.name)"></span>
            </div>
            <div class="zb_con_cons">
              <span v-html="formatet(item.doctor)"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 50px"></div>
      <!-- 提示注册弹窗 -->
      <LoginPrompt
        @promptFun="promptFun"
        ref="prompt"
      ></LoginPrompt>
      <!-- 尾部 -->
      <MinFooter headIndex="0"></MinFooter>
    </div>
  </div>
</template>

<script>
import MinHeader from "@/components/m_assembly/MinHeader.vue"; //头部模块
import MinFooter from "@/components/m_assembly/MinFooter.vue"; //尾部模块
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import MListLi from "@/components/assembly/m_listLi.vue"; //列表数据模块
import Hezuo from '@/components/tool/m_hezuo.vue'

import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";

export default {
  name: "m_new_search",
  data () {
    return {
      head_index: 1, //1发现 2推荐 3关注 4热门
      is_pc: true, //是否是pc端打开
      user: {}, //用户信息
      page: 1,
      list_arr: [],

      searchText: "", //搜索内容
      is_request: false,
      tabindex: 1,
      is_more: true,
      type: 1,
      oidug: true
    };
  },
  computed: {
    MembershipType: function () {
      return this.MembershipGrade(this.user.plus);
    },
  },
  components: {
    MinHeader,
    MinFooter,
    LoginPrompt,
    MListLi,
    Hezuo
  },
  watch: {
    head_index: function (eve) {
      this.page = 1;
      this.getList();
    },
  },
  created () {
    this.oidug = true
  },
  methods: {
    //   格式化文字
    formatet (msg) {
      let sou = this.searchText;
      let str = msg.replace(
        new RegExp(sou, "g"),
        '<span style="color:red">' + sou + "</span>"
      );
      return str;
    },
    searchFun (text) {
      if (text === "") {
        this.list_arr = [];
        this.page = 1;
        return;
      }
      this.searchText = text;
      this.page = 1;
       
      this.getList();
    },
    detailsFun (id) {
      //查看详情
      this.$router.push({ path: "/m_column_details", query: { id: id } });
    },
    details (liem) {
      //直播跳转页面
      if (!this.is_judge(liem)) {
        return false;
      }
      let id = liem.id;
      let record_url = liem.record_url;
      let power = liem.power;
      if (this._isMobile()) {
        // alert("手机端");
        if (liem.type === 0) {
          //直播
          this.$router.push({
            path: "min_move",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "min_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      } else {
        // alert("pc端");
        if (this.selectBox_index == 1) {
          //直播
          this.$router.push({
            path: "pc_move",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "pc_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      }
    },
    is_judge (liem) {
      //判断登录
      //  
      if (!liem.detail || !liem.detail.power) {
        //  
        if (liem.power == 0) {
          return true;
        }
        if (liem.detail.power == 0) {
          return true;
        }
      if (!this.USER() || this.USER().length == 0) {
          this.$refs.header.promptShow();
          // layer.open({
          //   content: "请先登录账号",
          //   time: true,
          //   skin: "msg"
          // });
          // setTimeout(()=>{
          //   this.$refs.header.registered(1);
          // },1000)

          return false;
        }
        if (
          (this.USER().plus < 2 && liem.detail.power == 2) ||
          (this.USER().plus == 0 && liem.detail.power == 1)
        ) {
          layer.open({
            content: this.promptPermissions,
            time: true,
            skin: "msg",
          });
          return false;
        }
        return true;
      }
    },
    promptFun () {
      //提示弹窗回调
      this.$router.replace("/m_registered");
    },
    // 切换tab
    clicktab (num) {
      this.oidug = true
      this.list_arr = [];
      this.page = 1;
      this.tabindex = num;
      this.getList();
    },
     // 跳转
    godetitl (item) {
      //  
      this.$router.push({
        path: "/m_vedio_dteil",
        query: { id: item.video_id, configid: item.video_conf_id},
      });
    },
    //文章详情
    new_details (id) {
      this.$router.push({
        path: "/m_column_details",
        query: { id: id, head_index: 2 },
      });
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();
      that.user = that.USER();
      that.getList();
    },
    getList () {
      //获取列表数据
      let that = this;
      if (this.page == 1) {
        this.list_arr = [];
      }
      if (this.tabindex === 3) {
        this.type = 2;
      } else if (this.tabindex === 2) {
        this.type = 3;
      } else {
        this.type = 1;
      }
      this.$post("index-search", {
        type: this.type,
        member_id: this.USER().id,
        limit: 10,
        keyword: this.searchText,
        page: this.page,
      }).then((res) => {
        this.oidug = false

         
        if (this.tabindex === 3) {
          that.list_arr = that.list_arr.concat(res.data);
           
          return;
        }
        that.list_arr = that.list_arr.concat(res.data.data);
         
      });
    },
  },
  activated () {
    this.oidug = false
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
      this.$refs.header.headerFun(this.searchText);
    }
  },
  mounted () {
    this.oidug = false
    if (this.$route.query.ffg) {
      this.tabindex = this.$route.query.ffg;
    }
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
      this.$refs.header.headerFun(this.searchText);
    }
    document.title = "麻醉眼界";
    this.getShare();
    this.getUser();
    if (this._isMobile()) {
    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
    let that = this;
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 100 >= scrollHeight) {
        that.page++;
        that.getList();
      }
    });
  },
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
}

#index {
  padding-top: 0;
}

header.header {
  box-shadow: 0 !important;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem !important;
}
.searchtext {
  width: 84vw;
  height: 10.13vw;
  font-size: 3.73vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  padding: 6vw 8vw;
}
.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.tab1 {
  padding: 6vw 17vw;
  padding-top: 0vw;
}
.tab1 div {
  display: flex;
  justify-content: space-around;
}
.tab1 span {
  font-size: 4.27vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  opacity: 1;
  padding: 0px 2vw;
  z-index: 9;
}
.tabactiv {
  position: absolute;
  bottom: 0.1vw;
  left: 0.5vw;
  width: 11.73vw;
  height: 2.13vw;
  background: #fee632;
  opacity: 1;
  border-radius: 0vw;
  z-index: 1;
}
/* 栏目 */
.lm_head {
  margin-top: 7vw;
  padding: 0px 4vw;
  margin-bottom: 10px;
}
.lm_title {
  width: 91.59vw;
  height: 21.03vw;
  background: url("../../assets/img/lanmubac.png") no-repeat;
  background-size: cover;
}
.lm_tit_top {
  width: 87.59vw;
  height: 4.79vw;
  line-height: 4.79vw;
  display: flex;
  justify-content: space-between;
  margin: 0px auto;
  padding-top: 4.26vw;
}
.lm_tit_top span:first-child {
  width: 9.58vw;
  height: 4.79vw;
  font-size: 4.79vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
}
.lm_tit_top span:last-child {
  width: 16.64vw;
  height: 3.19vw;
  font-size: 3.19vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 1;
}
.lm_tabs {
  width: 100%;
  height: 8vw;
  position: absolute;
  bottom: 0px;
}
.tabs_contnet {
  width: 88.59vw;
  display: flex;
  justify-content: space-between;
}
.lm_tabs span {
  margin-left: 2vw;
  height: 7vw;
  line-height: 6.19vw;
  font-size: 3.19vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
}
.tabacrive {
  border-bottom: 1vw solid #65b6fb;
}
.lm_con_item {
  width: 91.59vw;
  height: 23.43vw;
  box-shadow: 0vw 1vw 2vw rgba(0, 0, 0, 0.25);
  border-radius: 2vw;
  margin: 0 auto;

  margin-top: 2.93vw;
}
.lm_con_item img {
  vertical-align: bottom;
  width: 39.14vw;
  height: 23.43vw;
  background: #12687e;
  border-radius: 1vw 0rem 0rem 1vw;
}
.lm_con_right {
  width: 40vw;
  height: 23.43vw;
  margin-left: 4.7vw;
}
.lm_con_top {
  width: 43.66vw;
  height: 5.52vw;
  font-size: 3.19vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 3.73vw;
}
.lm_con_mm {
  width: 42.67vw;
  height: 6.33vw;
  font-size: 2.13vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 2vw;
}
.lm_con_bot {
  width: 42.66vw;
  font-size: 2.13vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  opacity: 1;
  display: flex;
  justify-content: space-between;
}
.spvidio {
  width: 91.59vw;
  margin-left: 6vw;
}
.spvideoimg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.spvidio > div {
  margin-top: 3.2vw;
  float: left;
  width: 42.13vw;
  height: 28.27vw;
  border: 0px solid #b381fe;
  opacity: 1;
  border-radius: 1vw;
  position: relative;
}
.spvidio > div:nth-child(even) {
  margin-left: 3vw;
}
.top_left_over {
  position: absolute;
  bottom: 0px;
  width: 42.07vw;
  height: 24.23vw;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  opacity: 1;
  border-radius: 1vw;
}
.play_icon {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -40%);
  width: 8vw;
  height: 8vw;
}
.video_title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  position: absolute;
  left: 50%;
  bottom: 2.2vw;
  font-size: 3.2vw;
  width: 35.73vw;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  color: #fff;
}
.clearfix:after {
  content: "."; /*加一段内容*/
  display: block; /*让生成的元素以块级元素显示，占满剩余空间*/
  height: 0; /*避免生成的内容破坏原有布局高度*/
  clear: both; /*清除浮动*/
  visibility: hidden; /*让生成的内容不可见*/
}
.clearfix {
  zoom: 1; /*为IE6，7的兼容性设置*/
}
.zb_con_item {
  margin-top: 5vw;
  width: 44.73vw;
  float: left;
}
.zb_con_item {
  margin-left: 3.4vw;
}
.zb_con_item img {
  width: 44.73vw;
  height: 25.29vw;
  border: 0px solid #b381fe;
  opacity: 1;
  border-radius: 1vw;
  background-color: aquamarine;
  margin-bottom: 2.13vw;
}
.zb_con_item .zb_con_title,
.zb_con_cons {
  width: 44.2vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.zb_con_title {
  margin-bottom: 1.33vw;
  color: #333333;
  font-size: 3.19vw;
  font-weight: 600;
}
.zb_con_cons {
  font-size: 2.13vw;
  color: #666666;
}
.zb_content {
}
.renwu {
  display: inline-block;
  width: 67%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_new_search.vue